import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.33 2a1 1 0 0 1 .98.783l2.159 9.717H22a1 1 0 1 1 0 2h-4.333a1 1 0 0 1-.977-.783l-1.34-6.035-2.372 11.028a1 1 0 0 1-1.927.106l-2.54-7.619-1.271 2.726a1 1 0 0 1-.907.577H2a1 1 0 1 1 0-2h3.696L7.76 8.077a1 1 0 0 1 1.855.107l2.177 6.529L14.356 2.79A1 1 0 0 1 15.33 2",
      clipRule: "evenodd"
    }
  )
);
var SvgActivityFeedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ActivityFeedFilled_default = SvgActivityFeedFilled;

export { ActivityFeedFilled_default as default };
